const BADGE_ASPECT_HEIGHT = 0.86;

export { BADGE_ASPECT_HEIGHT };
